<div class="email-sent-confirmation-container container-fluid h-100">
  <div class="row mb-4">
    <div class="col-10 offset-1 col-md-6 offset-md-3">
      <a [href]="links.home">
        <om-logo class="mx-auto mt-5"></om-logo>
      </a>
      <h1 class="mt-5 text-center">Email Sent</h1>
      <p class="body-small p-0 mb-3"
        >If an account exists with this email, you'll receive reset instructions shortly.
      </p>
      <div class="mt-5 mb-5">
        <p class="body-small p-0 mb-3 fw-bold">Haven't received the email within 30 minutes?</p>
        <ul class="list-unstyled text-start p-0 mb-3">
          <li class="body-small mb-2"
            ><span class="me-2">•</span>Verify your login email is correct (this may differ from the email where you
            receive notifications)</li
          >
          <li class="body-small mb-2"
            ><span class="me-2">•</span>If you typically sign in using your Amazon account, return to the login page and
            select "Log in with Amazon"</li
          >
        </ul>
      </div>
      <p class="body-small">
        For additional support, contact us at
        <a data-cy="contact-support-email" href="mailto:{{ contactEmail }}">{{ contactEmail }}</a
        >.
      </p>
    </div>
  </div>
</div>
